// Meta (Facebook) Pixel integration.
// Pixel-ID wird ausschließlich über die Environment-Variable REACT_APP_META_PIXEL_ID gesetzt.
// Ist keine ID gesetzt, bleibt der Pixel vollständig inaktiv (kein Script-Load, keine Events).

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
let initialized = false;

export function isPixelEnabled() {
  return Boolean(PIXEL_ID);
}

// Lädt das fbq-Basisskript genau einmal und initialisiert den Pixel.
export function initPixel() {
  if (initialized || !PIXEL_ID || typeof window === "undefined") return;
  if (window.fbq) {
    initialized = true;
    return; // bereits vorhanden -> keine doppelte Initialisierung
  }
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  initialized = true;
}

export function trackPageView() {
  if (!PIXEL_ID || typeof window === "undefined" || !window.fbq) return;
  window.fbq("track", "PageView");
}

export function trackEvent(event, params) {
  if (!PIXEL_ID || typeof window === "undefined" || !window.fbq) return;
  if (params) window.fbq("track", event, params);
  else window.fbq("track", event);
}
